
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/boss",
      function () {
        return require("private-next-pages/boss.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/boss"])
      });
    }
  